module.exports = __webpack_public_path__ + "static/media/RELEASE-NOTES.a42c7329.md";


//////////////////
// WEBPACK FOOTER
// ./src/assets/RELEASE-NOTES.md
// module id = 1595
// module chunks = 0